<template>
  <div class="qairn-app">
    <Header />
    <div class="container">
      <Parameters :jsonCode="jsonCode" />
      <PhoneView :jsonCode="jsonCode"/>
    </div>
  </div>
</template>

<script>
  import ElementUI from 'element-ui'
  import lang from 'element-ui/lib/locale/lang/fr'
  import locale from 'element-ui/lib/locale'
  import Header from './Header.vue';
  import Parameters from './Parameters/Parameters.vue';
  import PhoneView from './PhoneView/PhoneView.vue';

  locale.use(lang)

  export default {
    components: {
      ElementUI,
      locale,
      Header,
      Parameters,
      PhoneView
    },
    props: {
        jsonCode: Object
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/QairnComponent.vue